(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this._lastHeaderHeight = null;

      this.setHeaderHeight();
      this.onBreakpointChange = this.onBreakpointChange || this.setHeaderHeight.bind(this);
      this.mobileBreakpoint = this.mobileBreakpoint || window.matchMedia('(max-width: 990px)');
      this.mobileBreakpoint.addEventListener('change', this.onBreakpointChange);

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;
      this.preventRevealAtTop = false;
      this.preventRevealUntil = 0;
      this.preventRevealTimer = null;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = this.lockHeaderReveal.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const nextHeaderHeight = `${this.header.offsetHeight}px`;
      if (this._lastHeaderHeight === nextHeaderHeight) return;
      document.documentElement.style.setProperty('--header-height', nextHeaderHeight);
      this._lastHeaderHeight = nextHeaderHeight;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mobileBreakpoint && this.onBreakpointChange) {
        this.mobileBreakpoint.removeEventListener('change', this.onBreakpointChange);
      }
      if (this.preventRevealTimer) window.clearTimeout(this.preventRevealTimer);
      if (this.isScrolling) window.clearTimeout(this.isScrolling);
    }

    lockHeaderReveal(event) {
      const duration = Math.max(Number(event?.detail?.duration) || 900, 0);
      this.preventReveal = true;
      this.preventRevealAtTop = event?.detail?.allowAtTop === true;
      this.preventRevealUntil = Date.now() + duration;
      if (this.preventRevealTimer) window.clearTimeout(this.preventRevealTimer);
      this.preventRevealTimer = window.setTimeout(() => {
        if (Date.now() >= this.preventRevealUntil) {
          this.releaseHeaderRevealLock();
        }
      }, duration);
    }

    releaseHeaderRevealLock() {
      this.preventReveal = false;
      this.preventRevealAtTop = false;
      this.preventRevealTimer = null;
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerTop = Number(this.headerBounds?.top) || 0;
      if (scrollTop > headerTop) return;

      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
      this.currentScrollTop = scrollTop;
    }

    shouldPreventReveal() {
      if (!this.preventReveal) return false;
      if (Date.now() >= this.preventRevealUntil) {
        this.releaseHeaderRevealLock();
        return false;
      }
      return true;
    }

    createObserver() {
      if (!this.header) return;
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isSearchModalOpen() || (this.predictiveSearch && this.predictiveSearch.isOpen)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.shouldPreventReveal()) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        if (this.preventRevealAtTop && this.shouldPreventReveal()) {
          this.header.classList.add('scrolled-past-header');
          requestAnimationFrame(this.hide.bind(this));
          this.currentScrollTop = scrollTop;
          return;
        }
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      if (this.preventHide || this.isSearchModalOpen()) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal.header__search');
      if (typeof this.searchModal?.close === 'function') this.searchModal.close(false);
    }

    isSearchModalOpen() {
      return !!this.header.querySelector('details-modal.header__search details[open]');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
